module.exports = __webpack_public_path__ + "img/Nicquao_Cercle.4aa462eb.png";